module.exports = __webpack_public_path__ + "static/img/fsmt.7ac73d99.png";